<template>
  <div class="mb-1">
      <form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col">
            <select class="form-control" v-model="priority">
              <option value="2">High</option>
              <option value="1">Normal</option>
              <option value="0">Low</option>
            </select>
          </div>
          <div class="col">
            <select class="form-control" v-model="projectId">
              <option v-for="project in projects" :value="project.id">{{project.title}}</option>
            </select>
          </div>
          <div class="col">
            <select class="form-control" v-model="assigneeId">
              <option :value="null">Unassigned</option>
              <option v-for="user in availableWorkers" :value="user.id">{{user.fullname}}</option>
            </select>
          </div>
          <div class="col">
            <input type="text" class="form-control" v-model="title" ref="titleInput" @keydown="onTitleKeypress" />
          </div>
          <div class="col">
            <button type="submit" class="btn btn-primary btn">Add</button>
          </div>
        </div>
      </form>
  </div>
</template>

<script>

 export default {
   props: [
     'workers',
     'projects',
   ],
   data() {
     return {
       title: '',
       projectId: null,
       assigneeId: null,
       priority: 1,
     };
   },
   created() {
     this.projectId = this.projects[0] ? this.projects[0].id : null;
   },
   watch: {
     projects() {
       this.projectId = this.projects[0] ? this.projects[0].id : null;
     },
     projectId() {
       if (this.availableWorkerIds.indexOf(this.assigneeId) === -1) {
         this.assigneeId = null;
       }
     }
   },
   computed: {
     availableWorkers() {
       return this.workers[this.projectId] ? this.workers[this.projectId] : [];
     },
     availableWorkerIds() {
       return this.availableWorkers.map(user => user.id);
     },
     selectedAssigneeIndex() {
       return this.availableWorkerIds.indexOf(this.assigneeId);
     }
   },
   methods: {
     onSubmit() {
       this.$emit('submit', {
         title: this.title,
         projectId: this.projectId,
         assigneeId: this.assigneeId,
         priority: this.priority,
       });
       this.title = '';
     },
     onTitleKeypress(e) {
       if (e.key === 'ArrowUp') {
         e.preventDefault();
         if (this.selectedAssigneeIndex === 0) {
           this.assigneeId = null;
         } else if (this.selectedAssigneeIndex > 0) {
           this.assigneeId = this.availableWorkerIds[this.selectedAssigneeIndex - 1];
         }
       }
       if (e.key === 'ArrowDown') {
         e.preventDefault();
         if (this.selectedAssigneeIndex < this.availableWorkerIds.length - 1) {
           this.assigneeId = this.availableWorkerIds[this.selectedAssigneeIndex + 1];
         }
       }
     },
     focus() {
       this.$refs.titleInput.focus();
     }
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/kanban/TaskAdder.vue